import React from 'react'
import SalarySetupListTable from './components/SalarySetupListTable'
import AddItemBtn from 'Common/Custom/AddItemBtn';
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const SalarySetupList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Salary Setup List</HeadingOne>
                    <AddItemBtn url="add-salary-setup" title="Create Salary Setup" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <SalarySetupListTable />
            </div>
        </PageBody>
    );
};

export default SalarySetupList;
